import React from "react";
import { MenuItem, Divider, Stack, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

import { Strings } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";

interface UserMenuItemsProps {
  selectedItem: string | null;
  onSelect: (item: string) => void;
  onEditProfile: () => void;
  onMyOrders: () => void;
  onLogout: () => void;
  handleClose: () => void;
}

const UserMenuItems = ({
  selectedItem,
  onSelect,
  onEditProfile,
  onMyOrders,
  onLogout,
  handleClose,
}: UserMenuItemsProps) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Stack sx={{ py: 2, mt: 6 }}>
      <MenuItem
        onClick={() => {
          onSelect("edit");
          onEditProfile();
          handleClose();
          navigate(PATH_DASHBOARD.myProfile);
        }}
        sx={{
          color:
            selectedItem === "edit" ? theme.palette.primary.main : "inherit",
          fontFamily: "Work Sans",
          fontWeight: "300",
          gap: 1,
        }}
      >
        <Icon
          icon="tabler:edit"
          width={20}
          color={
            selectedItem === "edit" ? theme.palette.primary.main : undefined
          }
        />
        {Strings.userDropDownMenu.editProfile}
      </MenuItem>

      <Divider />

      <MenuItem
        onClick={() => {
          onSelect("orders");
          onMyOrders(); 
          handleClose();
          navigate(PATH_DASHBOARD.myOrders);
        }}
        sx={{
          color:
            selectedItem === "orders" ? theme.palette.primary.main : "inherit",
          fontFamily: "Work Sans",
          fontWeight: "300",
          gap: 1,
        }}
      >
        <Icon
          icon="mdi:clipboard-text-outline"
          width={20}
          color={
            selectedItem === "orders" ? theme.palette.primary.light : undefined
          }
        />
        {Strings.userDropDownMenu.myOrders}
      </MenuItem>

      <Divider />

      <MenuItem
        onClick={onLogout}
        sx={{
          color: "error.main",
          fontFamily: "Work Sans",
          fontWeight: "300",
          gap: 1,
        }}
      >
        <Icon icon="hugeicons:logout-01" width={20} />
        {Strings.userDropDownMenu.logout}
      </MenuItem>
    </Stack>
  );
};

export { UserMenuItems };
